import React from 'react'
import { Link } from "react-router-dom"
import {
  PermissionList,
  DeletePermission,
  searchAccessPermission } from '../../../../api/requests/data-access/DataAccessRequest'
import { ReadableDateTime } from '../../../../helpers/DateTime'
import LoadingOverlay from 'react-loading-overlay'
import Notification from '../../../helpers/Notification'
import { Modal, Button } from 'react-bootstrap'
import { 
  fetchSubUsers
} from '../../../../api/requests/user/UserRequest'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const SubscriberList = () => {
    let [loading, setLoading] = React.useState(false);
    const [notification, setNotification] = React.useState(false);
    const [notificationFlag, setNotificationFlag] = React.useState('');
    const [notificationMessage, setNotificationMessage] = React.useState('');
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [alert, setAlert] = React.useState([]);
    const [result, setResult] = React.useState([]);
    const [removeId, setRemoveId] = React.useState(0);
    const [parentId, setParentId] = React.useState(0);
    const [subUsers, setSubUsers] = React.useState([]);
    const [fetchUsers, setFetchUsers] = React.useState([]);
    const [allPermission, setAllPermission] = React.useState([]);
    const [permissionSearch, setPermissionSearch] = React.useState("");

    React.useEffect(() => {
      const data = async () => {
        setLoading(true);
        const access_list = await PermissionList();

        if (access_list) {
            setTimeout(() => {
                setAlert(access_list.data);
                setAllPermission(access_list.data);
                setLoading(false);
            }, 800)
        }
      }
      data()
    }, [])
    const removePermission = async () => {
      try {
        setLoading(true)
        window.scrollTo({ top: 0, behavior: 'smooth' })
        const result = await DeletePermission(removeId, parentId)
        if (result) {
            setTimeout(() => {
                setLoading(false)
            }, 800)
            setNotification(true)
            setNotificationFlag('success')
            setNotificationMessage(result.message)
            const re_alert_list = alert.filter((item) => {
              if(item._id !== removeId) return item
            })
            setAlert(re_alert_list)
        }

        setTimeout(() => {
          setNotification(false)
        }, 2000)

        return result
      } catch(err) {
        return false
      }
    }
    const addRemoveId = (item) => {
      setRemoveId(item._id)
      setParentId(item.client_id)
      return true
    }
    const viewSubUsers = async (id) => {
      setShowModal(true)
      const result = await fetchSubUsers(id)
      setSubUsers(result.data);
    }

    const handleAccessSearch = async (e) => {
      e.preventDefault();
      setLoading(true);
      if (permissionSearch.length > 0) {
          const result = await searchAccessPermission(permissionSearch);
          setAlert(result.data);
      }
      setLoading(false);
    }
  
    const handleReset = (e) => {
      e.preventDefault();
      setPermissionSearch("");
      setAlert(allPermission);
    }

    return (
      <>
        <LoadingOverlay active={loading} spinner text='Loading Data ... ...'>
          <div style={{minHeight:90+'vh'}}>
            <header className="page-header">
                <div className="d-flex align-items-center">
                    <div className="mr-auto">
                        <h1 className="separator">Data Access Permission</h1>
                        <nav className="breadcrumb-wrapper" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <span><i className="icon dripicons-home"></i></span>
                                </li>
                                <li className="breadcrumb-item">
                                    <span>Data Service</span>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Permission List
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </header>

            <section className="page-content container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <form className="card-header">
                                <span>
                                  Client Name or Email
                                </span>
                                <input
                                    type="text"
                                    style={{ margin: "0 1rem" }}
                                    value={permissionSearch}
                                    onChange={(e) =>
                                      setPermissionSearch(e.target.value)
                                    }
                                />
                                <button
                                    type="submit"
                                    className="btn-primary"
                                    style={{ marginRight: "1rem" }}
                                    onClick={handleAccessSearch}
                                >
                                    Search
                                </button>
                                <button
                                    className="btn-secondary"
                                    onClick={handleReset}
                                >
                                    Reset
                                </button>
                            </form>
                            <div className="card-body">
                                {notification ? <Notification flag={notificationFlag} msg={notificationMessage} /> : ''}
                                <div className="table-responsive">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Client</th>
                                                <th>Email</th>
                                                <th>From Date</th>
                                                <th>To Date</th>
                                                <th>Created At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {alert.length ? alert.map((item) => (
                                                <tr key={item._id}>
                                                    <td>{item.client_name}</td>
                                                    <td>
                                                      <strong>{item.user_email}</strong>
                                                    </td>
                                                    <td>{ReadableDateTime(item.start_date)}</td>
                                                    <td>{ReadableDateTime(item.expired_at)}</td>
                                                    <td>{ReadableDateTime(item.created_at)}</td>
                                                    <td>
                                                        <Link
                                                            to={`/permission/access-details/${item._id}`}
                                                            className="badge badge-pill badge-primary"
                                                            title="Access details">
                                                            <i className="la la-eye" style={{color: '#fff'}}></i>
                                                        </Link>

                                                        <Link
                                                            to={`/permission/list/edit/${item._id}`}
                                                            className="badge badge-pill badge-warning"
                                                            title="Edit Permission">
                                                            <i className="la la-edit" style={{color: '#fff'}}></i>
                                                        </Link>

                                                        <span
                                                            className="badge badge-pill badge-success"
                                                            title="View Sub Users"
                                                            onClick={() => viewSubUsers(item.client_id)}
                                                        >
                                                            <i className="la la-user-plus" style={{color: '#fff'}}></i>
                                                        </span>

                                                        <span
                                                            onClick={() => addRemoveId(item)}
                                                            data-toggle="modal"
                                                            data-target=".bd-example-modal-sm"
                                                            className="badge badge-pill badge-danger"
                                                            title="Remove Permission">
                                                            <i className="la la-remove" style={{color: '#fff'}}></i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            )) : 'Subscriber Not Found'}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <Modal size="lg" show={showModal} onHide={() => setShowModal(false)}>
                              <Modal.Header>
                                  <Modal.Title>
                                      Sub Users List
                                  </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="table-responsive">
                                  <table className="table table-striped">
                                    <thead>
                                      <tr>
                                        <th>ID</th>
                                        <th>Email</th>
                                        <th>Status</th>
                                        <th>Created At</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {subUsers.length > 0 
                                      ? subUsers.map((data) => (
                                      <tr key={data.id}>
                                          <td>{data.uid}</td>
                                          <td>{data.email}</td>
                                          <td>{data.status == 1 ? 'Active' : 'Inactive'}</td>
                                          <td>{ReadableDateTime(data.created_at)}</td>
                                          <td>
                                            <Link to={`/user/sub-user/service-access/${data.uid}`}>
                                              <span
                                                className="badge badge-pill badge-warning"
                                                title="Edit User Permission">
                                                <i className="zmdi zmdi-settings zmdi-hc-fw" style={{color: '#fff'}}></i>
                                              </span>
                                            </Link>
                                          </td>
                                      </tr>
                                      )) : 'No sub user found'}
                                    </tbody>
                                  </table>
                                </div>  
                              </Modal.Body>
                              <Modal.Footer>
                                  <Button variant="primary" onClick={() => setShowModal(false)}>
                                      Close
                                  </Button>
                              </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </section>

            <div className="modal fade bd-example-modal-sm" tabIndex="-1" role="dialog" aria-hidden="true">
        			<div className="modal-dialog modal-sm">
        				<div className="modal-content">
        					<div className="modal-header">
        						<h5 className="modal-title" id="ModalTitle4">Remove Permission</h5>
        						<button type="button" className="close" data-dismiss="modal" aria-label="Close">
        							<span aria-hidden="true" className="zmdi zmdi-close"></span>
        						</button>
        					</div>
        					<div className="modal-body">
        						<p>Do you want to delete selected user data access permission ?</p>
        					</div>
        					<div className="modal-footer">
        						<button type="button" className="btn btn-success btn-outline" data-dismiss="modal">No</button>
        						<button type="button" className="btn btn-danger" data-dismiss="modal" onClick={removePermission}>Yes</button>
        					</div>
        				</div>
        			</div>
        		</div>
          </div>
        </LoadingOverlay>
      </>
    )
  }

export default SubscriberList;
